import isLoading from './is-loading'
import requestHolidays from '../request/holidays'
import setHolidays from '../action/set-holidays'
import loadWorkspaceDetail from './load-workspace-detail'
import store from '../store'
import moment from 'moment'
import { SentryError } from '@app/util/sentry/sentry-error'

export default (variables) => {
  return async (dispatch) => {
    const { workspaceId, workspaces, me } = store.getState()
    if (!workspaceId) return
    if (!variables.period || !variables.period.start || !variables.period.end) return

    const ws = workspaces.find(ws => ws.id === workspaceId)
    if (!ws) return

    dispatch(isLoading('load-holidays'))

    // the country is only known once the workspace detail is loaded, which happens
    // asynchronously - right after a workspace switch the store can still hold the
    // workspace without it. the query requires the country, so we make sure the detail
    // is loaded before asking for the holidays.
    let country = ws.country
    if (!country) {
      await dispatch(loadWorkspaceDetail(workspaceId, true))
      country = store.getState().workspaces.find(w => w.id === workspaceId)?.country
    }
    if (!country) {
      // eslint-disable-next-line no-new
      new SentryError('load-holidays: workspace has no country, skipping the request', {
        extras: { workspaceId }
      })
      dispatch(isLoading('load-holidays', true))
      return
    }

    const params = Object.assign({}, { country, lang: me.language }, variables)

    // get the holidays for the period from BE
    let resultHolidays
    try {
      resultHolidays = await requestHolidays(params)
    } catch (e) {
      // a failed holidays request must not take down the whole calendar load
      // eslint-disable-next-line no-new
      new SentryError(`load-holidays: ${e?.message}`, { extras: { params } })
      dispatch(isLoading('load-holidays', true))
      return
    }

    // and add all the other, previously loaded events to the list
    // (read from the store only now - it may have changed while we were awaiting above)
    const { holidays } = store.getState()
    resultHolidays = ((resultHolidays && resultHolidays.length) ? resultHolidays : []).concat(holidays.filter(h => moment(h.date).isBefore(variables.period.start) || moment(h.date).isAfter(variables.period.end)))
    await dispatch(setHolidays(resultHolidays))

    dispatch(isLoading('load-holidays', true))
    return resultHolidays
  }
}
